/* eslint-disable react/prop-types */
// layouts/catalogos/sellos/datasellos
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { ui } from "ui/tokens";

export const columns = [
  { name: "sello", align: "left", sortable: true },
  { name: "group", label: "Grupo", align: "center" }, // 👈 encabezado "Grupo"
  { name: "creado", align: "center", sortable: true },
  { name: "action", align: "center" },
];

const formatDate = (d) => {
  if (!d) return "-";
  try {
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return d;
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yy = String(dt.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  } catch {
    return d;
  }
};

export default function buildSellosTableData(items = [], adapter) {
  const rows = (items || []).map((raw, idx) => {
    const s = adapter
      ? adapter(raw, idx)
      : {
          id: raw.id ?? raw._id ?? idx,
          nombre: raw.name ?? raw.nombre ?? "-",
          groupId: raw.group_id ?? raw.groupId ?? "-",
          // si viene anidado el grupo, tomamos el nombre; si no, el id
          groupLabel:
            raw.group?.name ??
            raw.group_name ??
            raw.group ??
            raw.group_id ??
            raw.groupId ??
            "-",
          creado: raw.created_at ?? raw.createdAt,
          onEdit: () => {},
          onDelete: () => {},
        };

    return {
      sello: (
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography variant="button" fontWeight="medium">
            {s.nombre}
          </SoftTypography>
        </SoftBox>
      ),
      group: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {s.groupLabel ?? s.groupId ?? "-"}
        </SoftTypography>
      ),
      creado: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {formatDate(s.creado)}
        </SoftTypography>
      ),
      action: (
        <SoftBox display="flex" gap={0.5} justifyContent="center">
          <Tooltip title="Editar">
            <IconButton
              size="small"
              onClick={(e) => {
                e.preventDefault();
                s.onEdit?.(s);
              }}
              sx={{
                "& .icon-edit": { color: ui.icon?.edit?.base || "#0ea5e9" },
                "&:hover .icon-edit": { color: ui.icon?.edit?.hover || "#0284c7" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-edit" fontSize="small">
                edit
              </Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton
              size="small"
              onClick={(e) => {
                e.preventDefault();
                s.onDelete?.(s);
              }}
              sx={{
                "& .icon-del": { color: ui.icon?.del?.base || "#ef4444" },
                "&:hover .icon-del": { color: ui.icon?.del?.hover || "#b91c1c" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-del" fontSize="small">
                delete
              </Icon>
            </IconButton>
          </Tooltip>
        </SoftBox>
      ),
    };
  });

  return { columns, rows };
}
